import React from "react";
import numeral from "numeral";
import { Timestamp } from "components/common";
const ExecutionInfo = ({ duration, executedAt, total = void 0, showTotal = true, executionFinished }) => {
  if (!executionFinished) {
    return /* @__PURE__ */ React.createElement("i", null, "No query executed yet.");
  }
  return /* @__PURE__ */ React.createElement("i", null, "Query executed in ", numeral(duration).format("0,0"), "ms at ", /* @__PURE__ */ React.createElement(Timestamp, { dateTime: executedAt }), " ", showTotal && /* @__PURE__ */ React.createElement(React.Fragment, null, "Total results: ", numeral(total).format("0,0")));
};
export default ExecutionInfo;
